// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hover-transparent[data-v-54d6f7aa]:hover{opacity:50%}`, "",{"version":3,"sources":["webpack://./../blocks/manage_groups/documents3/components/orders-list-page.vue"],"names":[],"mappings":"AACA,0CACE,WAAA","sourcesContent":["\n.hover-transparent:hover {\n  opacity: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
